var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIconBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.69754 12C8.69754 14.1333 10.4439 15.8691 12.6 15.8691C14.7463 15.8691 16.4927 14.1333 16.4927 12C16.4927 9.85697 14.7463 8.12121 12.6 8.12121C10.4439 8.12121 8.69754 9.85697 8.69754 12ZM18.3366 6.04606C20.0439 7.36485 21.4975 9.29455 22.5414 11.7091C22.6195 11.8933 22.6195 12.1067 22.5414 12.2812C20.4536 17.1103 16.7366 20 12.6 20H12.5902C8.46339 20 4.74632 17.1103 2.65851 12.2812C2.58046 12.1067 2.58046 11.8933 2.65851 11.7091C4.74632 6.88 8.46339 4 12.5902 4H12.6C14.6683 4 16.6292 4.71758 18.3366 6.04606ZM12.6011 14.4124C13.9377 14.4124 15.0304 13.3264 15.0304 11.9979C15.0304 10.6597 13.9377 9.57362 12.6011 9.57362C12.4841 9.57362 12.367 9.58332 12.2597 9.60272C12.2207 10.6694 11.3426 11.5227 10.2597 11.5227H10.2109C10.1816 11.6779 10.1621 11.833 10.1621 11.9979C10.1621 13.3264 11.2548 14.4124 12.6011 14.4124Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIconBlack);
export default __webpack_public_path__ + "static/media/eyeIconBlack.79eaf64e8d585498323a28cc25d3aaac.svg";
export { ForwardRef as ReactComponent };